// test1787
(1787 && 0);
